import { lazy, Suspense } from "react";
import { IS_SANDBOX, RUNTIME_MODE } from "../config/runtime";
import { ProductionApp } from "./ProductionApp";

const LegacyApp = lazy(() => import("../legacy-main.jsx"));

export function AppShell() {
  if (!IS_SANDBOX) {
    return <ProductionApp />;
  }
  return (
    <>
      <aside className="runtime-banner" role="status" data-testid="runtime-banner">
        沙箱 / MOCK 环境（{RUNTIME_MODE}）：数据和操作仅用于演示，不得用于临床决策
      </aside>
      <Suspense fallback={<main className="production-shell">正在加载沙箱工作台…</main>}>
        <LegacyApp />
      </Suspense>
    </>
  );
}
